module.exports = __webpack_public_path__ + "img/full4-min.f8038633.png";